import React from 'react';
import { any } from 'prop-types';

import apikoLogoUrl from '../../static/imgs/apiko-logo.svg';
import ModalWindow from '../../modals/modal-window';
import { ApikoImg, PreviewPageWrap } from './styles';


export const PreviewLayout = ({ children }) => (
  <PreviewPageWrap>
    <ApikoImg src={apikoLogoUrl} alt="apiko logo" />
    {children}
    <ModalWindow />
  </PreviewPageWrap>
);

PreviewLayout.propTypes = {
  children: any,
};

PreviewLayout.defaultProps = {
  children: null,
};



// WEBPACK FOOTER //
// ./src/layouts/preview/component.js